var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14401_351559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4186 6.5V12.5H27.2607L21.4186 6.5ZM19.9581 12.5V6.5H11.9252C10.7152 6.5 9.73438 7.50734 9.73438 8.75V28.25C9.73438 29.4922 10.7152 30.5 11.9252 30.5H25.0699C26.2799 30.5 27.2607 29.4927 27.2607 28.25V14H21.4597C20.6107 14 19.9581 13.3297 19.9581 12.5ZM22.8837 22.6297C22.7102 22.8922 22.4318 23 22.1488 23C21.8659 23 21.5884 22.8901 21.3743 22.6704L19.5929 20.8391V25.625C19.5929 26.2461 19.1023 26.75 18.4975 26.75C17.8928 26.75 17.4021 26.2461 17.4021 25.625V20.8391L15.6208 22.6686C15.1929 23.108 14.4998 23.108 14.0717 22.6686C13.6436 22.2291 13.6438 21.5173 14.0717 21.0777L17.723 17.3277C18.1509 16.8882 18.844 16.8882 19.2721 17.3277L22.9234 21.0777C23.3492 21.5187 23.3492 22.2313 22.8837 22.6297Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14401_351559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5263,
    height: 24,
    fill: "white",
    transform: "translate(9.73438 6.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.8b97d0b30ad6b62b714a960d7e55dd5a.svg";
export { ForwardRef as ReactComponent };